<template>
  <div class='position-grid' style="height:100%">
    <dx-data-grid ref='refPositionGrid'
      :remote-operations="false"
      :data-source='positionInfoList'
      :show-borders = 'true' :showRowLines = 'true' :showColumnLines='true'
      :hover-state-enabled = "true" :allowColumnResizing = 'true'
      column-resizing-mode = 'widget' :allow-column-reordering = "true"
      :height='gridHeight' :row-alternation-enabled="true"
      keyExpr="seqId" :focusedRowEnabled="true"  @focused-row-changed="onFocusedRowChanged"
      @editor-preparing='onEditorPreparing' @toolbarPreparing="onToolbarPreparing"
      @exporting="onExcelExporting"
      @row-updated='onRowUpdated'
      @rowDblClick ='onRowDbClick'
    >
      <DxSearchPanel
        :visible="true"
        placeholder="검색..."
      />
      <DxExport
        :enabled="true"
      />
      <DxStateStoring
        :enabled="false"
        type="localStorage"
        storage-key="positionResult"
      />
      <DxFilterRow
        :visible="true"
        apply-filter="auto"
      />
      <DxEditing
        :allow-deleting="false"
        :allow-updating="true"
        :allow-adding="false"
        :use-icons="true"
        mode='row'
      >
      </DxEditing>
      <DxColumnFixing :enabled="true"/>
      <DxColumn
      :allowEditing="false"
      :visible="true"
      caption="고객사명"
      data-field="고객사명"
      :min-width="130"
      :fixed="true"
      >
      </DxColumn>
      <DxColumn
      :allowEditing="false"
      :visible="true"
      caption="포지션제목"
      data-field="포지션제목"
      :fixed="true"
      :min-width="220"
      sortOrder="asc"
      >
      </DxColumn>
      <DxColumn
        caption="기본정보"
      >
        <DxColumn
        :allowEditing="false"
        :visible="true"
        caption="합격자"
        data-field="성명"
        alignment="center"
        :min-width="80"
        >
        </DxColumn>
        <DxColumn
        :allowEditing="false"
        :visible="true"
        caption="등록일"
        data-field="createdTime"
        alignment="center"
        format="yyyy-MM-dd"
        dataType="date"
        :min-width="90"
        >
        </DxColumn>
        <DxColumn
        :allowEditing="false"
        :visible="true"
        caption="합격일"
        data-field="합격일"
        alignment="center"
        format="yyyy-MM-dd"
        dataType="date"
        :min-width="90"
        >
        </DxColumn>
        <DxColumn
        :allowEditing="false"
        :visible="true"
        caption="메인"
        data-field="컨설턴트"
        alignment="center"
        :min-width="80"
        >
          <DxLookup
            :data-source="employeeInfo"
            display-expr="성명"
            value-expr="사번"
          />
        </DxColumn>
        <DxColumn
        :allowEditing="false"
        :visible="true"
        caption="코웍"
        data-field="코웍컨설턴트"
        alignment="center"
        :min-width="80"
        >
          <DxLookup
            :data-source="employeeInfo"
            display-expr="성명"
            value-expr="사번"
          />
        </DxColumn>
      </DxColumn>
      <DxColumn
        caption="수수료 정보"
      >
        <DxColumn
        :allowEditing="false"
        :visible="true"
        caption="계약연봉"
        data-field="계약연봉"
        format="#,##0"
        dataType="number"
        :min-width="100"
        >
        </DxColumn>
        <DxColumn
          :allowEditing="false"
          :visible="true"
          caption="수수료율"
          data-field="수수료율"
          format="#,##0.0%"
          dataType="number"
          :min-width="80"
        >
        </DxColumn>
        <DxColumn
          :allowEditing="false"
          :visible="true"
          caption="청구금액"
          data-field="청구금액"
          :calculate-cell-value="calculateFee"
          format="#,##0"
          dataType="number"
          :min-width="100"
        >
        </DxColumn>
        <DxColumn
        :allowEditing="true"
        :visible="true"
        caption="수수료청구"
        data-field="수수료청구"
        alignment="center"
        :min-width="90"
        >
          <DxLookup
            :data-source="feeReqState"
            display-expr="코드명"
            value-expr="코드명"
          />
          <DxRequiredRule message="항목을 입력하세요"/>
        </DxColumn>
        <DxColumn
          :allowEditing="true"
          :visible="true"
          caption="입금금액"
          data-field="수금금액"
          format="#,##0"
          dataType="number"
          :min-width="100"
        >
        </DxColumn>
        <DxColumn
          :allowEditing="false"
          :visible="true"
          caption="미수금액"
          data-field="미수금액"
          :calculate-cell-value="calculateMisu"
          format="#,##0"
          dataType="number"
          :min-width="100"
        >
        </DxColumn>
        <DxColumn
          :allowEditing="false"
          :visible="isAdmin"
          caption="회사수입"
          data-field="회사수입"
          :calculate-cell-value="calculateCompanyFee"
          format="#,##0"
          dataType="number"
          :min-width="100"
        >
        </DxColumn>
        <DxColumn
        :allowEditing="true"
        :visible="true"
        caption="단독/코웍"
        data-field="단독"
        :calculate-cell-value="calculateCowork"
        alignment="center"
        :min-width="80"
        >
          <DxLookup
            :data-source="coworkLookup"
            display-expr="코드명"
            value-expr="코드명"
          />
        </DxColumn>
        <DxColumn
          :allowEditing="false"
          :visible="true"
          caption="메인수입"
          data-field="메인수입"
          :calculate-cell-value="calcMainFee"
          format="#,##0"
          dataType="number"
          :min-width="100"
        >
        </DxColumn>
        <DxColumn
          :allowEditing="false"
          :visible="true"
          caption="코웍수입"
          data-field="코웍수입"
          :calculate-cell-value="calcCoworkFee"
          format="#,##0"
          dataType="number"
          :min-width="100"
        >
        </DxColumn>
      </DxColumn>

      <DxSummary>
        <DxTotalItem
          value-format='#,##0'
          show-in-column="고객사명"
          display-format="{0} (건)"
        />
        <DxTotalItem
          value-format='#,##0'
          summary-type="sum"
          column="청구금액"
          display-format="{0}"
        />
        <DxTotalItem
          value-format='#,##0'
          summary-type="sum"
          column="수금금액"
          display-format="{0}"
        />
        <DxTotalItem
          value-format='#,##0'
          summary-type="sum"
          column="미수금액"
          display-format="{0}"
        />
        <DxTotalItem
          value-format='#,##0'
          summary-type="sum"
          column="회사수입"
          display-format="{0}"
        />
        <DxTotalItem
          value-format='#,##0'
          summary-type="sum"
          column="메인수입"
          display-format="{0}"
        />
        <DxTotalItem
          value-format='#,##0'
          summary-type="sum"
          column="코웍수입"
          display-format="{0}"
        />
      </DxSummary>
      <dx-paging :enabled="false"/>
      <dx-scrolling mode="virtual" showScrollbar='always' :useNative='false'/>
      <dx-sorting mode="multiple"/>
    </dx-data-grid>
    <div class="position-detail">
      <DxPopupGen
        :visible.sync="popupPositionDetail"
        :drag-enabled="true"
        :close-on-outside-click="true"
        :show-title="true"
        :width="1000"
        :height="editPopupHeight"
        title="포지션 정보"
      >
        <template #content>
          <DxScrollView
            width="100%"
            height="100%"
          >
            <DxForm
              id="form"
              :col-count="2"
              :form-data="positionDetail"
            >
              <DxSimpleItem data-field="고객사명"/>
              <DxSimpleItem data-field="포지션제목"/>
              <DxSimpleItem data-field="수수료율"/>
              <DxSimpleItem data-field="컨설턴트"/>
              <DxSimpleItem data-field="코웍여부"/>
              <DxSimpleItem data-field="코웍수수료"/>
              <DxSimpleItem data-field="모집분야"/>
              <DxSimpleItem data-field="채용직급"/>
              <DxSimpleItem data-field="경력"/>
              <DxSimpleItem data-field="학력"/>
              <DxSimpleItem data-field="선호성별"/>
              <DxSimpleItem data-field="선호연령"/>
              <DxSimpleItem data-field="기숙조건"/>
              <DxSimpleItem data-field="기타처우"/>
            </DxForm>
            <div style="margin-top:10px;">포지션 정보 :</div>
            <DxHtmlEditor
              :value="positionDetail['포지션정보']"
              height="300px"
            >
            </DxHtmlEditor>
            <div style="margin-top:10px;">채용 정보 :</div>
            <DxHtmlEditor
              :value="positionDetail['채용정보']"
              height="300px"
            >
            </DxHtmlEditor>
          </DxScrollView>
        </template>
      </DxPopupGen>
    </div>
    <loading :active.sync="isLoading" color='rgb(2, 110, 156)' loader='bars'></loading>
  </div>
</template>

<script>
import Loading from 'vue-loading-overlay'
import ConstDef from '../../share/ConstDef'
import DxDataGrid, { DxFilterRow, DxExport, DxColumnFixing, DxTotalItem, DxSummary, DxPaging, DxScrolling,
  DxColumn, DxSorting, DxEditing, DxSearchPanel, DxLookup, DxStateStoring } from 'devextreme-vue/data-grid'
import {
  DxRequiredRule
} from 'devextreme-vue/validator'
import {
  DxForm,
  DxSimpleItem
} from 'devextreme-vue/form'
import {
  DxHtmlEditor
} from 'devextreme-vue/html-editor'
import { DxScrollView } from 'devextreme-vue/scroll-view'
import { DxPopup as DxPopupGen } from 'devextreme-vue/popup'
import { Workbook } from 'exceljs'
import { saveAs } from 'file-saver-es'
import { exportDataGrid } from 'devextreme/excel_exporter'

export default {
  name: 'customerInfo',
  data: function () {
    return {
      isLoading: false,
      companyInfoList: null,
      gridHeight: null,
      userInfo: null,
      searchYear: this.$_appLib.getToday(),
      positionInfoList: null,
      selectedRow: null,
      feeReqState: ConstDef.FEE_REQ_LOOKUP,
      employeeInfo: this.$store.getters.getEmployee,
      coworkLookup: ConstDef.COWORK_LOOKUP,
      isAdmin: false,
      // popup
      popupPositionDetail: false,
      editPopupHeight: screen.height - 140,
      positionDetail: []
    }
  },
  components: {
    Loading,
    DxDataGrid,
    DxExport,
    DxFilterRow,
    DxPaging,
    DxColumnFixing,
    DxColumn,
    DxSorting,
    DxEditing,
    DxRequiredRule,
    DxSearchPanel,
    DxLookup,
    DxSummary,
    DxStateStoring,
    DxTotalItem,
    DxScrolling,
    DxPopupGen,
    DxForm,
    DxSimpleItem,
    DxHtmlEditor,
    DxScrollView
  },
  props: {
    option: {
      type: String,
      default: 'positionResult'
    }
  },
  created () {
    document.title = ConstDef.WEB_TAB_TITLE
    this.userInfo = this.$store.getters.getUserInfo
    if (this.userInfo === null) {
      this.$router.push('/')
    }
    if (this.userInfo.permission & ConstDef.CRUD_ALLOW_경영) {
      this.isAdmin = true
    }
    this.refreshPostionResult()
  },
  mounted () {
    this.gridHeight = (screen.height - 250)
  },
  updated () {
  },
  beforeDestroy: function () {

  },
  methods: {
    calcRow (cellElement, cellInfo) {
      this.$Q(cellElement).text(cellInfo.row.rowIndex + 1)
    },
    calculateFee (row) {
      return row.수수료율 * row.계약연봉
    },
    calculateMisu (row) {
      return row.수수료율 * row.계약연봉 - row.수금금액
    },
    calculateCompanyFee (row) {
      let mainFee = this.calcMainFee(row)
      let coworkFdd = this.calcCoworkFee(row)
      return (row.수수료율 * row.계약연봉) - mainFee - coworkFdd
    },
    calculateCowork (row) {
      let result = '단독'
      if (row.컨설턴트 !== row.코웍컨설턴트) {
        result = '코웍'
      }
      return result
    },
    calcCoworkFee (row) {
      let result = 0
      let 수수료 = (row.수수료율 * row.계약연봉)
      if (row.컨설턴트 !== row.코웍컨설턴트) {
        let coworkFee = 수수료 * row.코웍수수료
        if (this.isAdmin) {
          result = coworkFee - (coworkFee * row.코웍회사수수료율)
        } else {
          result = coworkFee
        }
      }
      return result
    },
    calcMainFee (row) {
      let mainFee = 0
      let 수수료 = mainFee = (row.수수료율 * row.계약연봉)
      // console.log(row.컨설턴트, row.코웍컨설턴트)
      if (row.컨설턴트 !== row.코웍컨설턴트) {
        let coworkFee = 수수료 - 수수료 * row.코웍수수료
        // console.log(coworkFee)
        mainFee = 수수료 - coworkFee
        // console.log(mainFee)
      }
      let result = mainFee - (mainFee * row.메인회사수수료율)

      return result
    },
    onEditorPreparing (e) {

    },
    onExcelExporting (e) {
      const workbook = new Workbook()
      const worksheet = workbook.addWorksheet('채용정보')
      exportDataGrid({
        component: e.component,
        worksheet,
        autoFilterEnabled: true
      }).then(() => {
        workbook.xlsx.writeBuffer().then((buffer) => {
          saveAs(new Blob([buffer], { type: 'application/octet-stream' }), `${this.searchYear.substring(0, 4)}년_합격자.xlsx`)
          this.isExporing = false
        })
      })
      e.cancel = true
    },
    onRowDbClick (row) {
      this.$_sp.runFindSqlProc('채용정보', { seqId: row.data.채용정보코드 })
        .then(data => {
          this.positionDetail = this.$_sp.MakeModel(data)[0]
          this.popupPositionDetail = true
        })
    },
    onUpdating (row) {
    },
    onRowUpdated (row) {
      console.log(row.data)
      const param = {
        seqId: row.data.seqId,
        수수료청구: row.data.수수료청구,
        수금금액: row.data.수금금액
      }
      if (row.data.수수료청구 === '입금완료') {
        row.data.수금금액 = param.수금금액 = row.data.수수료율 * row.data.계약연봉
      }
      console.log(param)
      this.$_sp.runUpdateSqlProc('채용정보별지원자', ['seqId'], null, [param])
        .then(data => {
          this.$snotify.info('저장 되었습니다.')
        })
        .catch(error => {
          this.isLoading = false
          if (error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            this.$snotify.error(`에러코드 : ${error.response.status}`)
          }
        })
    },
    onFocusedRowChanged (e) {
      if (e != null && e.row === undefined) {
        return
      }
      if (e !== null) {
        this.selectedRow = e.row.data
      }
    },
    onToolbarPreparing (e) {
      if (this.option === 'positionResult') {
        e.toolbarOptions.items.unshift(
          {
            location: 'before',
            template: function () {
              return `<div class="toolbar-label" style='margin-left:4px;color:blue;'><b>검색연도(합격일) : </b></div>`
            }
          },
          {
            location: 'before',
            widget: 'dxDateBox',
            options: {
              width: 80,
              value: this.searchYear,
              type: 'date',
              calendarOptions: {
                maxZoomLevel: 'decade',
                minZoomLevel: 'century'
              },
              displayFormat: 'yyyy',
              onInitialized: (args) => {
                this.fromDateBox = args.component
              },
              onValueChanged: (args) => {
                this.searchYear = args.value
                this.refreshPostionResult()
              }
            }
          }
        )
      }
    },
    refreshPostionResult () {
      const param = {
        fromDate: `${this.searchYear.substring(0, 4)}-01-01`,
        toDate: `${this.searchYear.substring(0, 4)}-12-31 23:59:59`,
        option: this.option,
        regId: this.userInfo.permission & ConstDef.CRUD_ALLOW_경영 ? 'ALL' : this.userInfo.userId
      }
      this.$_sp.runFindProc('spFindAllPositionResultByYear', param)
        .then(data => {
          this.positionInfoList = this.$_sp.MakeModel(data)
          console.log(this.positionInfoList)
        })
        .catch(error => {
          this.isLoading = false
          if (error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            this.$snotify.error(`에러코드 : ${error.response.status}`)
          }
        })
    }

  }
}
</script>

<style lang="scss">
  .dx-popup-content{
    padding: 20px 40px;
    .dx-field-item-label{
      width: 130px;
    }
  }
</style>
